import { useEffect, useState, useLayoutEffect } from "react";
import { Row, Col, Container, Button } from "react-bootstrap";
import axios from "axios";
import { Alert } from "react-bootstrap";

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL || ''}/api`;

//import image1 from "./image1.png";
const Visuals = () => {
useEffect(() => {
  document.title = "Enigma Labs | Marketing, Social Media, Photography & Videography in Miami & South Florida";
  document.querySelector('meta[name="description"]')?.setAttribute(
    "content",
    "Marketing, digital marketing, social media marketing & management, ads, content creation, branding, graphic design, photography, videography, event photography & videography and music videos for businesses and artists in Miami, Fort Lauderdale, Kendall, Brickell, Homestead, the Florida Keys and all of South Florida — up to Tampa & Orlando."
  );
}, []);

const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [beats, setBeats] = useState(false);
  const [visuals, setVisuals] = useState(false);
  const [web, setWeb] = useState(false);
  const [ads, setAds] = useState(false);
  const [message, setMessage] = useState("");
  const [alert, setAlert] = useState("");
  // Honeypot — real users never see or fill this; bots that auto-fill every
  // input on the page do. Combined with formLoadedAt (a timing trap: humans
  // take at least a few seconds to fill the form) on the backend.
  const [honeypot, setHoneypot] = useState("");
  const [formLoadedAt] = useState(() => Date.now());

  const rowStyle = {
    margin: '2%',
    alignItems: 'center',
  };

  const imgStyle = {
    height: "250px",
    width: "100%",
    maxWidth: "100%",
    marginRight: "20px",
    display: "block",
    objectFit: "cover" as const,
};

const videoStyle = {
  height: "250px",
  width: "auto"
};

const infoCardStyle = {
  backgroundColor: "#111",
  border: "1px solid #68FF00",
  borderRadius: "20px",
  boxShadow: "0 0 20px rgba(104, 255, 0, 0.12)",
  padding: "2rem 1.75rem",
  height: "100%"
};

const newsletterCardStyle = {
  backgroundColor: "#111",
  border: "1px solid #68FF00",
  borderRadius: "20px",
  boxShadow: "0 0 30px rgba(104, 255, 0, 0.15)",
  width: "100%",
  padding: "2.75rem 2rem"
};

const newsletterInputStyle = {
  display: "block",
  margin: "0 auto 1.5rem",
  width: "100%",
  maxWidth: "360px",
  padding: "0.85rem 1.15rem",
  borderRadius: "2rem",
  border: "1px solid #333",
  backgroundColor: "#1a1a1a",
  color: "#fff",
  fontSize: "1rem",
  outline: "none"
};

const newsletterButtonStyle = {
  marginTop: "1.75rem",
  padding: "0.85rem 2.75rem",
  backgroundColor: "#68FF00",
  color: "#000",
  border: "none",
  borderRadius: "2rem",
  fontWeight: 700,
  textTransform: "uppercase" as const,
  letterSpacing: "0.05em",
  fontSize: "1rem",
  cursor: "pointer"
};

const newsletterChipStyle = (active: boolean) => ({
  display: "inline-block",
  padding: "0.55rem 1.1rem",
  margin: "0.3rem",
  borderRadius: "2rem",
  border: "1px solid #68FF00",
  backgroundColor: active ? "#68FF00" : "transparent",
  color: active ? "#000" : "#68FF00",
  fontWeight: 600,
  fontSize: "0.85rem",
  cursor: "pointer",
  userSelect: "none" as const,
  transition: "all 0.15s ease"
});

const interestOptions: { key: string; label: string; active: boolean; toggle: () => void }[] = [
  { key: "visuals", label: "Branding", active: visuals, toggle: () => setVisuals(!visuals) },
  { key: "web", label: "Web Development", active: web, toggle: () => setWeb(!web) },
  { key: "beats", label: "Beats & Mixing", active: beats, toggle: () => setBeats(!beats) },
  { key: "ads", label: "Ads", active: ads, toggle: () => setAds(!ads) },
];

function handleSubmit() {
    console.log('handle submit request to subscribe')
  
    // Check if data is valid
    if (!email) {
      console.log('No e-mail address provided');
      setAlert('Please set an e-mail address~');
      return;
    }

    const dataToSend = {
      email,
      name,
      phone,
      beats,
      visuals,
      web,
      ads,
      website: honeypot,
      formLoadedAt
    };

    // Make a POST request using Axios
    axios.post(`${API_BASE_URL}/newsletter/subscribe`, dataToSend, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(() => {
        console.log('Request successful');
        setMessage("Your e-mail has been saved!")
        setAlert(''); // Resetting alert if necessary
      })
      .catch((error) => {
        setAlert("There was an error.");
        console.error('Error: ', error);
        setMessage(''); // Resetting message if necessary
      });
  }

      return (
        <Container className="aboutContainer">
          
          <Row style={rowStyle}>
            <Col sm={12}>
              <h1 className="subpage-title aboutTitle">Branding | Marketing | Ads</h1>
            </Col>
          </Row>
          <Row style={rowStyle}>
            <Col sm={12}>
              <h5 className="subsection-title" style={{marginTop: "5%"}}>Services</h5>
              <ul>
                <li>Photography, Videography, Event Coverage, Music Videos, Content Creation</li>
                <li>Graphic Design: Logos, Branding, Album Covers, Business Cards, Stickers, Posters + more.</li>
                <li>Marketing, Social Media Management & Ads: Instagram, TikTok, YouTube, Facebook + more.</li>
              </ul>
            </Col>
          </Row>

          <Row style={rowStyle}>
            <Col sm={12}>
              <h2 className="subsection-title">PORTRAITS</h2>
            </Col>
          </Row>
         
            <Row style={rowStyle}>
            <Col sm={4}>
              <a href="https://www.instagram.com/_enigmalabs/" target="_blank"><img style={imgStyle} className="servicesImg"  src="/portrait5.jpg" /></a>
            </Col>
            <Col sm={4}>
              <a href="https://www.instagram.com/_enigmalabs/" target="_blank"><img style={imgStyle} className="servicesImg"  src="/portrait4.jpg" /></a>
            </Col>
            <Col sm={4}>
              <a href="https://www.instagram.com/_enigmalabs/" target="_blank"><img style={imgStyle} className="servicesImg"  src="/portrait6.jpg" /></a>
            </Col>
          </Row>
          <Row style={rowStyle}>
            <Col sm={4}>
              <a href="https://www.instagram.com/_enigmalabs/" target="_blank"><img style={imgStyle} className="servicesImg"  src="/portrait1.jpg" /></a>
            </Col>
            <Col sm={4}>
              <a href="https://www.instagram.com/_enigmalabs/" target="_blank"><img style={imgStyle} className="servicesImg"  src="/portrait2.jpg" /></a>
            </Col>
            <Col sm={4}>
              <a href="https://www.instagram.com/_enigmalabs/" target="_blank"><img style={imgStyle} className="servicesImg"  src="/portrait3.jpg" /></a>
            </Col>
          </Row>

          <Row style={rowStyle}>
            <Col sm={12}>
              <h2 className="subsection-title">EVENTS</h2>
            </Col>
          </Row>
          <Row style={rowStyle}>
            <Col sm={3}>
              <a href="https://www.instagram.com/igorcentrism/" target="_blank"><img style={imgStyle} className="servicesImg"   src="/IGOR.JPG" /></a>
            </Col>
            <Col sm={3}>
              <a href="https://www.instagram.com/soyhaky/" target="_blank"><img style={imgStyle} className="servicesImg"  src="/haky1.jpg" /></a>
            </Col>
            <Col sm={3}>
              <a href="https://www.instagram.com/gen.wav/" target="_blank"><img style={imgStyle} className="servicesImg"  src="/hakygen2.jpg" /></a>
            </Col>
             <Col sm={3}>
              <a href="https://www.instagram.com/soyhaky/" target="_blank"><img style={imgStyle} className="servicesImg"  src="/haky3.jpg" /></a>
            </Col>
          </Row>

          <Row style={rowStyle}>
            <Col sm={3}>
              <a href="https://www.instagram.com/_enigmalabs/" target="_blank"><img style={imgStyle} className="servicesImg"  src="/DANIMAKO EDIT.JPG" /></a>
            </Col>
            <Col sm={3}>
              <a href="https://www.instagram.com/nickgarcia305/" target="_blank"><img style={imgStyle} className="servicesImg"  src="/NICKGARCIA.JPG" /></a>
            </Col>
             <Col sm={3}>
              <a href="https://www.instagram.com/_enigmalabs/" target="_blank"><img style={imgStyle} className="servicesImg"  src="/JAZZ.JPG" /></a>
            </Col>
              <Col sm={3}>
              <a href="https://www.instagram.com/_enigmalabs/" target="_blank"><img style={imgStyle} className="servicesImg"   src="/ptaenigma.JPG" /></a>
            </Col>
          </Row>

          <Row style={rowStyle}>
            <Col sm={12}>
              <h2 className="subsection-title">STUDIO SESSIONS</h2>
            </Col>
          </Row>
          <Row style={rowStyle}>
            <Col sm={3}>
              <a href="https://www.instagram.com/neptunemiami/" target="_blank"><img style={imgStyle} className="servicesImg"   alt="mars studios" src="/ETHINWAVE.JPG" /></a>
            </Col>
            <Col sm={3}>
              <a href="https://www.instagram.com/marsmiamistudios/" target="_blank"><img style={imgStyle} className="servicesImg"   alt="mars studios" src="/ZICARIA.JPG" /></a>
            </Col>
              <Col sm={3}>
              <a href="https://www.instagram.com/marsmiamistudios/" target="_blank"><img style={imgStyle} className="servicesImg"   alt="mars studios" src="/MARS.JPG" /></a>
            </Col>
            <Col sm={3}>
              <a href="https://www.instagram.com/neptunemiami/" target="_blank"><img style={imgStyle} className="servicesImg"  alt="neptune studios" src="/ETHINWAVE2.jpg" /></a>
            </Col>
          </Row>

          <Row style={rowStyle}>
            <Col sm={12}>
              <h2 className="subsection-title">MUSIC VIDEOS</h2>
            </Col>
          </Row>
          <Row style={rowStyle}>

            <Col sm={6}>
            <iframe width="100%" height="315" src="https://www.youtube.com/embed/73bsecH1N2c?si=Y26DKm25bZp9nQMS" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" frameBorder="0" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            </Col>
            <Col sm={6}>
              <iframe width="100%" height="315" src="https://www.youtube.com/embed/FQyi0U0Hkrg?si=UMRNAqCKERphTPTi" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" frameBorder="0" allowFullScreen></iframe>
            </Col>
           
          </Row>
          <Row style={rowStyle}>
            <Col sm={6}>
            <iframe width="100%" height="315" src="https://www.youtube.com/embed/3wBxgLcn4-M?si=ZOhmNWgQ2QJ8cfxp" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" frameBorder="0" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            </Col>
              <Col sm={6}>
              <iframe width="100%" height="315" src="https://www.youtube.com/embed/UHvLtJjzu7A?si=hyz3KX0HbarmSp5H" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" frameBorder="0"  allowFullScreen></iframe>
            </Col>
          </Row>

            
           <Row style={rowStyle}>
          
            <Col sm={6}>
              
            </Col>
          </Row>


          <Row style={rowStyle}>
            <Col sm={12}>
              <h5 className="subsection-title" style={{marginTop: "5%"}}>Pricing</h5>
             
            </Col>
            <Col sm={6} style={{ marginBottom: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              <div style={{ ...infoCardStyle, height: 'auto' }}>
                <h6 style={{ color: "#68FF00", fontWeight: 700, marginBottom: "0.75rem" }}>Marketing</h6>
                <ul style={{ marginBottom: 0 }}>
                  <li><a href="https://square.link/u/0dFh75Gd" target="_blank" rel="noopener noreferrer" className="price-link">Social Media Management: <span className="price">$1000/mo</span> — 1 shoot day (4hr) + 4 weeks of scheduled content (4 videos, 8 image posts)</a></li>
                </ul>
                <h6 style={{ color: "#68FF00", fontWeight: 700, marginTop: "1.25rem", marginBottom: "0.75rem" }}>Music Promotion</h6>
                <ul style={{ marginBottom: 0 }}>
                  <li><a href="https://square.link/u/2Z8mCXP8" target="_blank" rel="noopener noreferrer" className="price-link">Music Release Rollout: <span className="price">$200</span> — 3 weeks of scheduled content across all platforms before, during &amp; after your release</a></li>
                  <li><a href="https://square.link/u/eCyRYB5C" target="_blank" rel="noopener noreferrer" className="price-link">Music Promo Full Package: <span className="price">$600</span> — 3 hr Run and Gun Music Video + Photoshoot, Album Cover, 20 edited pictures, 3 weeks of scheduled content across all platforms before, during &amp; after your release</a></li>
                </ul>
              </div>
              <div style={{ ...infoCardStyle, height: 'auto' }}>
                <h6 style={{ color: "#68FF00", fontWeight: 700, marginBottom: "0.75rem" }}>Ads</h6>
                <ul style={{ marginBottom: 0 }}>
                  <li><a href="https://square.link/u/oWzl59ES" target="_blank" rel="noopener noreferrer" className="price-link">Basic Ad Package: <span className="price">$200/mo</span> — includes $100 in ad spend, campaign setup, audience targeting &amp; management</a></li>
                  <li><a href="https://square.link/u/HvTxW0Iq" target="_blank" rel="noopener noreferrer" className="price-link">Standard Ad Package: <span className="price">$500/mo</span> — includes $250 in ad spend, campaign setup, audience targeting &amp; management</a></li>
                  <li><a href="https://square.link/u/CB72yXJX" target="_blank" rel="noopener noreferrer" className="price-link">Premium Ad Package: <span className="price">$1000/mo</span> — includes $500 in ad spend, campaign setup, audience targeting &amp; management</a></li>
                </ul>
              </div>
            </Col>
            <Col sm={6} style={{ marginBottom: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              <div style={{ ...infoCardStyle, height: 'auto' }}>
                <h6 style={{ color: "#68FF00", fontWeight: 700, marginBottom: "0.75rem" }}>Photography</h6>
                <ul style={{ marginBottom: 0 }}>
                  <li><a href="https://square.link/u/cuDKOR8q" target="_blank" rel="noopener noreferrer" className="price-link">1 HR Shoot 10 Edits: <span className="price">$100</span></a></li>
                  <li><a href="https://square.link/u/rTmMIOnl" target="_blank" rel="noopener noreferrer" className="price-link">2 HR Shoot 20 Edits: <span className="price">$200</span></a></li>
                  <li><a href="https://square.link/u/xTNdvj5B" target="_blank" rel="noopener noreferrer" className="price-link">Full Day Shoot / Event Coverage (8h) 100 Edits + Recap Video: <span className="price">$1000</span></a></li>
                </ul>
              </div>
              <div style={{ ...infoCardStyle, height: 'auto' }}>
                <h6 style={{ color: "#68FF00", fontWeight: 700, marginBottom: "0.75rem" }}>Videography</h6>
                <ul style={{ marginBottom: 0 }}>
                  <li><a href="https://square.link/u/SFzsRiSr" target="_blank" rel="noopener noreferrer" className="price-link">1HR Run and Gun Music Video: <span className="price">$200</span></a></li>
                  <li><a href="https://square.link/u/NYzpWdUX" target="_blank" rel="noopener noreferrer" className="price-link">2HR Run and Gun Music Video: <span className="price">$350</span></a></li>
                  <li><a href="https://square.link/u/x6ofQKWN" target="_blank" rel="noopener noreferrer" className="price-link">1HR Content Shoot + 2 Edits: <span className="price">$200</span></a></li>
                </ul>
              </div>
              <div style={{ ...infoCardStyle, height: 'auto' }}>
                <h6 style={{ color: "#68FF00", fontWeight: 700, marginBottom: "0.75rem" }}>Graphic Design</h6>
                <ul style={{ marginBottom: 0 }}>
                  <li><a href="https://square.link/u/NbpKaUWt" target="_blank" rel="noopener noreferrer" className="price-link">Logo Design: <span className="price">$100</span></a></li>
                  <li><a href="https://square.link/u/hUgXLWXV" target="_blank" rel="noopener noreferrer" className="price-link">Logo Design + 250 Business Cards: <span className="price">$150</span></a></li>
                  <li><a href="https://square.link/u/8JopaglI" target="_blank" rel="noopener noreferrer" className="price-link">Album Cover Design: <span className="price">$100</span></a></li>
                  <li><a href="https://square.link/u/mTD79ZpW" target="_blank" rel="noopener noreferrer" className="price-link">1 Hr Photo Shoot + Album Cover + 10 Edits: <span className="price">$150</span></a></li>
                </ul>
              </div>
            </Col>
          </Row>

          <hr style={{backgroundColor:"white", marginTop: "3%"}}/>

         
          <Row style={{ ...rowStyle, marginTop: "6%", marginBottom: "6%" }}>
            <Col xs={12} md={6} >
              <h4 className="mt-5">Reach Out to Us</h4>
              <a href="mailto:info@enigma-labs.com" className="text-white">info@enigma-labs.com</a>
             <div style={{marginBottom:"3%"}}></div>
            </Col>
            <Col xs={12} md={6} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <div style={newsletterCardStyle}>
                <form style={{ textAlign: "center", width: "100%", maxWidth: "420px", margin: "0 auto" }}>
                  <h3 style={{ color: "#68FF00", marginBottom: "0.25rem" }}>Sign Up For Our Newsletter</h3>
                  <p style={{ color: "#aaa", fontSize: "0.9rem", marginBottom: "1.5rem" }}>
                    News, tips and discounts. No spam.
                  </p>
                  {/* Honeypot — hidden from real users, tempting for bots that auto-fill every field */}
                  <input
                    type="text"
                    name="website"
                    value={honeypot}
                    onChange={(e) => setHoneypot(e.target.value)}
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    style={{ position: "absolute", left: "-9999px", width: "1px", height: "1px", opacity: 0 }}
                  ></input>
                  <input
                    type="text"
                    name="name"
                    placeholder="Your name"
                    style={newsletterInputStyle}
                    onChange={(e) => {
                      setName(e.target.value);
                    }}
                  ></input>
                  <input
                    type="email"
                    name="e-mail"
                    placeholder="your@email.com"
                    style={newsletterInputStyle}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                  ></input>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone number"
                    style={newsletterInputStyle}
                    onChange={(e) => {
                      setPhone(e.target.value);
                    }}
                  ></input>
                  <label style={{ display: "block", color: "#d4d4d4", marginBottom: "0.5rem" }}>
                    What are you interested in?
                  </label>
                  <div style={{ textAlign: "center" }}>
                    {interestOptions.map((option) => (
                      <span
                        key={option.key}
                        role="checkbox"
                        aria-checked={option.active}
                        tabIndex={0}
                        style={newsletterChipStyle(option.active)}
                        onClick={option.toggle}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            option.toggle();
                          }
                        }}
                      >
                        {option.label}
                      </span>
                    ))}
                  </div>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      handleSubmit();
                    }}
                    style={newsletterButtonStyle}
                    type="submit"
                  >
                    Submit
                  </button>
                  {message && <Alert style={{ marginTop: "1.5rem", backgroundColor: "#111", borderColor: "#68FF00", color: "#68FF00" }}>{message.toString()}</Alert>}
                  {alert && <Alert style={{ marginTop: "1.5rem", backgroundColor: "#2a0000", borderColor: "#ff4d4d", color: "#ff9d9d" }}>{alert.toString()}</Alert>}
                </form>
              </div>
            </Col>
          </Row>
          <style>{`
      @media (max-width: 600px) {
        .servicesImg {
          width: 100% !important;
          height: auto !important;
          max-width: 100% !important;
          object-fit: contain !important;
          margin-right: 0 !important;
          display: block !important;
        }
      }
    `}</style>
        </Container>

        
        
      );
  
};



export default Visuals;
//<img src={image1} style={{width: '100%', height: '80%'}}/>